'use strict';

var React = require('react');

var SvgHideKeyboardMajor = function SvgHideKeyboardMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 3.5a1.5 1.5 0 0 1 1.5-1.5h17a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5h-17a1.5 1.5 0 0 1-1.5-1.5v-7zm3 .5h2v2h-2v-2zm1 4v2h2v-2h-2zm8 2h-4v-2h4v2zm-3-6h-2v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm-1 6v-2h-2v2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 16.586-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414l-2.293 2.293z"
  }));
};

exports.SvgHideKeyboardMajor = SvgHideKeyboardMajor;
